import {log_metric_route} from './constants';
import {analytics, logEvent} from './notifications.js';

let metricBuffer = [];
let flushTimer = null;

async function flushMetrics() {
    const batch = metricBuffer;
    metricBuffer = [];

    for (const metric of batch) {
        try {
            await fetch(log_metric_route, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(metric)
            });
        } catch (error) {
            // fetch() rejects only on a network failure, so this is always a dropped beacon on
            // the user's connection rather than an app fault. Metrics are fire-and-forget and
            // nothing downstream depends on them, so report at info like the other network
            // failures instead of flooding the error stream (Rollbar #336 / #340 / #358).
            Rollbar.info("Log metric network failure: " + error);
        }
    }
}

export const logMetric = (value) => {
    Rollbar.captureEvent(value, 'info');
    logEvent(analytics, JSON.stringify(value));

    // Deduplicate: if buffer already has an entry with the same key, replace it
    const key = Object.keys(value)[0];
    const existingIndex = metricBuffer.findIndex(m => Object.keys(m)[0] === key);
    if (existingIndex !== -1) {
        metricBuffer[existingIndex] = value;
    } else {
        metricBuffer.push(value);
    }

    clearTimeout(flushTimer);
    flushTimer = setTimeout(flushMetrics, 2000);
};

// Flush pending metrics before page unloads to avoid losing buffered data
document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden' && metricBuffer.length > 0) {
        clearTimeout(flushTimer);
        flushMetrics();
    }
});

export {analytics, logEvent };
